import styled from 'styled-components';
import { UIData, useUIStore } from '../../../hooks/stores/uiStore';

export const FullViewButton = () => {
  const [UIData, setUIData] = useUIStore<UIData>();

  return (
    <Container
      onMouseEnter={() =>
        setUIData({
          isStateViewControllerFullView: true,
        })
      }
      onClick={() =>
        setUIData({
          isStateViewControllerFullView: !UIData.isStateViewControllerFullView,
        })
      }
      $isActive={UIData.isStateViewControllerFullView}
    >
      <Icon
        className="icon-arrow-right"
        style={{ rotate: UIData.isStateViewControllerFullView ? '90deg' : '-90deg' }}
      />
    </Container>
  );
};

const Container = styled.div<{ $isActive?: boolean }>`
  width: 200px;
  height: 28px;
  position: absolute;
  padding-bottom: 9px;

  display: flex;
  justify-content: center;
  align-items: center;

  color: var(--main-2);
  background-color: var(--neutral-2);
  border: 1px solid var(--neutral-3);
  border-radius: var(--radius-2);

  transition:
    background-color var(--transition-2),
    color var(--transition-2);

  ${({ $isActive }) => $isActive && `background-color: var(--neutral-3); color: var(--main-1);`}
`;

const Icon = styled.i`
  font-size: '11px';
`;
